import { H1, H2, H4, Shadows, VerticalGroup } from "@saysom/shared"
import React from "react"
import PersonRow from "../components/about/personRow"
import Body from "../components/body/body"
import DirectionSwitch from "../components/directionSwitch"
import { DottedBackground } from "../components/landing/recommendations/recommendations_style"
import { SmallContainer } from "../styles"

const About = () => {
	return (
		<Body
			className="bg-flowy-up dark:bg-flowy-up-dark"
			whiteFooter
			subtitle="About"
		>
			<H1
				style={{ marginBottom: "40px", marginTop: "120px" }}
				className="bg-flowy-text bg-clip-text text-transparent self-center"
			>
				Bringing people back together
			</H1>
			<H4
				style={{
					maxWidth: "640px",
					marginBottom: "120px",
					textAlign: "justify",
				}}
				className="self-center leading-6"
			>
				Never before humanity has been so connected and at the same time so far
				away from each other. But the most beautiful moments are the ones you
				can share with someone else - no matter if it`&apos;s in business or
				private life. Together, despite distance. This is exactly what SaySom
				has made its goal: to reconnect people with each other.
			</H4>

			<VerticalGroup>
				<H1
					style={{ marginBottom: "40px" }}
					className="bg-flowy-text bg-clip-text text-transparent self-start"
				>
					Our Values
				</H1>
				<DirectionSwitch>
					<SmallContainer
						align="center"
						shadow={Shadows.highlighted}
						className="text-black dark:text-white bg-white dark:bg-black space-y-4"
					>
						<H2
							style={{ marginBottom: "8px" }}
							// className="bg-flowy-text bg-clip-text text-transparent"
						>
							Trust
						</H2>
						<H4 className="opacity-70">
							We own our behaviour, keep our promises, value honesty, honor the
							community environment in wich we operate and embrace diversity.
						</H4>
					</SmallContainer>
					<SmallContainer
						align="center"
						shadow={Shadows.highlighted}
						className="text-black dark:text-white bg-white dark:bg-black space-y-4"
					>
						<H2
							// className="bg-flowy-text bg-clip-text text-transparent"
							style={{ marginBottom: "8px" }}
						>
							Innovation
						</H2>
						<H4 className="opacity-70">
							We use creativity and persistence to solve problems. We deeply
							respects the knowledge, skills, ideas, and capabilities that each
							employee brings to the team.
						</H4>
					</SmallContainer>

					<SmallContainer
						align="center"
						shadow={Shadows.highlighted}
						className="text-black dark:text-white bg-white dark:bg-black space-y-4"
					>
						<H2
							style={{ marginBottom: "8px" }}
							// className="bg-flowy-text bg-clip-text text-transparent"
						>
							Empowerment
						</H2>
						<H4 className="opacity-70">
							Empower those around you. Share what you know and attempt to make
							those around you better than yourself.
						</H4>
					</SmallContainer>
					<SmallContainer
						align="center"
						shadow={Shadows.highlighted}
						className="text-black dark:text-white bg-white dark:bg-black space-y-4"
					>
						<H2
							// className="bg-flowy-text bg-clip-text text-transparent"
							style={{ marginBottom: "8px" }}
						>
							Integrity
						</H2>
						<H4 className="opacity-70">
							We believe that integrity is at the heart of our individual and
							corporate actions.
						</H4>
					</SmallContainer>
				</DirectionSwitch>
			</VerticalGroup>

			<H1
				style={{ marginBottom: "40px", marginTop: "180px" }}
				className="bg-flowy-text bg-clip-text text-transparent self-start"
			>
				Team
			</H1>

			<div className="flex flex-row text-black dark:text-white space-x-8">
				<p style={{ flex: 3, textAlign: "justify" }}>
					The founding team got to know each other in their school days and
					stayed in touch despite various educational backgrounds. With similar
					problems in mind, they developed SaySom in June 2020 - a digital space
					for groups to connect, collaborate and create memories.
				</p>
				<div className="flex-1 hidden sm:flex" />
			</div>

			<div className="relative py-5 mt-12 mb-16">
				<div className="hidden md:block md:absolute w-24 md:w-3/4 left-0 top-0 bottom-0 pr-3">
					<DottedBackground />
				</div>

				<PersonRow
					name="Cornelius Carl"
					position="CEO & Co-founder"
					twitter="https://twitter.com/ccoryoso"
					instagram="https://www.instagram.com/coryoso"
					linkedIn="https://www.linkedin.com/in/cornelius-carl/"
					image="cornelius"
					imageClassName="left-0 md:left-20"
				/>

				<PersonRow
					name="Antonia Pervanidis"
					position="CMO & Co-founder"
					twitter="https://twitter.com/antonia59791130"
					instagram="https://www.instagram.com/antonia_paola_p"
					linkedIn="https://www.linkedin.com/in/antonia-pervanidis-926ab914b"
					image="antonia"
					imageClassName="right-0 md:right-36"
				/>

				<PersonRow
					name="Jan-Niklas Dihlmann"
					position="CPO & Co-founder"
					twitter="https://twitter.com/jdihlmann"
					instagram="https://www.instagram.com/jdihlmann/"
					linkedIn="https://www.linkedin.com/in/jan-niklas-dihlmann-b29649201/"
					image="jan-niklas"
					imageClassName="left-0 md:left-44"
				/>

				<PersonRow
					name="Nicolas Mahren"
					position="Programmer"
					twitter="https://twitter.com/nico41307687"
					instagram="https://www.instagram.com/nico_m125/"
					linkedIn="https://www.linkedin.com/in/nicolas-mahren-574a37144/"
					image="nicolas"
					imageClassName="right-0 md:right-16"
				/>

				<div className="flex flex-row items-center">
					<div className="w-auto md:w-3/4 flex items-center flex-col">
						<div className="bg-white rounded-full relative p-4 left-0 md:left-20">
							<img
								src="/assets/images/you.gif"
								width="75px"
								height="75px"
								srcSet="/assets/images/you.gif 1x, /assets/images/you@2x.gif 2x"
								className="rounded-full border-2 border-white bg-white max-w-100 max-h-100"
								style={{
									boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.16)",
								}}
								alt=""
							/>
						</div>
					</div>
					<div className="w-auto md:w-1/4 pl-4 flex flex-1 flex-row justify-between">
						<H2>You?</H2>
						{/* <ContinueButton
							href={`/contact?reason=${ContactType.Job}`}
							isBlack
							text="Contact"
							className="self-start"
						/> */}
					</div>
				</div>
			</div>
		</Body>
	)
}

export default About
